import { ExternalLink, Play, ShoppingBag, Trophy } from "lucide-react";

export default function FootballWall() {
  return (
    <section id="football" className="py-24 md:py-32 relative overflow-hidden bg-zinc-900/50 border-y border-white/5">
      <img
        src="https://customer-assets-cm19k8pv.emergentagent.net/job_curry-bound-chase/artifacts/m9myiqob_IMG_5479.webp"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-15"
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <p className="font-sub text-xs tracking-[0.2em] uppercase font-bold text-purple-400 mb-3">Colonels Nation</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase mb-4">
          The Curry <span className="text-purple-400">Football Wall</span>
        </h2>
        <p className="font-sub text-base md:text-lg text-zinc-400 max-w-2xl mb-12">
          Watch the Colonels play live on the one and only purple turf, and rep the team with official gear.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 rounded-3xl overflow-hidden bg-zinc-950 border border-white/5">
            <div className="relative aspect-video bg-gradient-to-br from-purple-950 to-zinc-950 flex items-center justify-center">
              <div className="text-center px-6">
                <div className="w-20 h-20 mx-auto rounded-full bg-purple-600/20 border border-purple-500/50 flex items-center justify-center mb-6">
                  <Play className="w-8 h-8 text-purple-400 ml-1" />
                </div>
                <h3 className="font-sub font-bold text-xl text-white mb-2">Curry Colonels Live Stream</h3>
                <p className="text-sm text-zinc-400 mb-6 max-w-md mx-auto">
                  All home games stream live on Curry Athletics. Tune in on game day and watch Chase ball out.
                </p>
                <a
                  href="https://curryathletics.com/watch"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="livestream-link"
                  className="inline-flex items-center gap-2 font-sub font-semibold bg-purple-600 hover:bg-purple-500 text-white px-8 py-4 rounded-full transition-colors duration-200 drop-shadow-[0_0_20px_rgba(147,51,234,0.5)] active:scale-95"
                >
                  Watch Live <ExternalLink className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <a
              href="https://curryathletics.com/sports/football"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="team-page-link"
              className="group flex-1 rounded-3xl bg-zinc-950 border border-white/5 hover:border-purple-500/50 p-8 flex flex-col justify-between hover:-translate-y-1 transition-[transform,border-color] duration-300"
            >
              <Trophy className="w-8 h-8 text-purple-400 mb-4" />
              <div>
                <h3 className="font-sub font-bold text-lg text-white flex items-center gap-2">
                  Colonels Football <ExternalLink className="w-4 h-4 text-zinc-500 group-hover:text-purple-400 transition-colors duration-200" />
                </h3>
                <p className="text-sm text-zinc-400 mt-2">Schedule, roster, and stats — official Curry Athletics team page.</p>
              </div>
            </a>
            <a
              href="https://www.bkstr.com/currycollegestore/home"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="bookstore-link"
              className="group flex-1 rounded-3xl bg-zinc-950 border border-white/5 hover:border-purple-500/50 p-8 flex flex-col justify-between hover:-translate-y-1 transition-[transform,border-color] duration-300"
            >
              <ShoppingBag className="w-8 h-8 text-purple-400 mb-4" />
              <div>
                <h3 className="font-sub font-bold text-lg text-white flex items-center gap-2">
                  Curry Bookstore <ExternalLink className="w-4 h-4 text-zinc-500 group-hover:text-purple-400 transition-colors duration-200" />
                </h3>
                <p className="text-sm text-zinc-400 mt-2">Textbooks, Curry gear, and Colonels merch — shipped to Chase or to you.</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
